<button mat-icon-button (click)="editRepairAction(repairActionDialogTemplate)" color="primary">
  <mat-icon>edit</mat-icon>
</button>
<button mat-icon-button (click)="deleteRepairAction()" color="warn">
  <mat-icon>delete</mat-icon>
</button>
<ng-template #repairActionDialogTemplate>
  <app-repair-service-action-dialog></app-repair-service-action-dialog>
</ng-template>
